<div class="row">
    <div class="col-12">
        <h2>Sorry, You don't have access to this page!</h2>
        <p>If you think this is wrong and you should have access to this resource, please get in touch with support.</p>

        <p class="fw-bold">
            If you have recently activated a module or integration please sign out and back in again for the change to
            take effect.
        </p>
    </div>
</div>
